<template>
    <div>
        <v-img
        :src="getImage(contents[0])"
        class="transparent mb-4"
        contain
        v-if="getImage(contents[0]) != ''"
        >
            <template v-slot:placeholder>
                <v-layout
                fill-height
                align-center
                justify-center
                ma-0
                >
                <v-progress-circular indeterminate color="grey lighten-1"></v-progress-circular>
                </v-layout>
            </template>
        </v-img>
        <!-- <div>
            <a href="#/About%20Us/Organization%20Structure/profiles">View profiles of division heads</a>
        </div> -->
        <div>
            <v-row>
                <v-col cols="12" md="6" v-for="head in divisionHeads" :key="head.ID">
                    <v-row>
                        <v-col cols="6" md="5">
                            <v-card height="170" class="align-center elevation-2" style="border-radius: 50%">
                                <v-img
                                height="170"
                                v-if="head.Files[0]"
                                :src="`${$url}/downloadfile/${head.Files[0].ID}`"
                                :lazy-src="`${$url}/downloadfile/${head.Files[0]}`"
                                class="transparent lighten-2 white--text align-end"
                                position="top"
                                >
                                    <template v-slot:placeholder>
                                        <v-layout
                                            fill-height
                                            align-center
                                            justify-center
                                            ma-0
                                            >
                                            <v-progress-circular indeterminate color="grey lighten-1"></v-progress-circular>
                                        </v-layout>
                                    </template>
                                </v-img>
                                <v-img
                                v-else
                                height="170"
                                src="../assets/user.png"
                                :lazy-src="'../assets/user.png'"
                                class="transparent lighten-2 white--text align-end"
                                >
                                    <template v-slot:placeholder>
                                        <v-layout
                                            fill-height
                                            align-center
                                            justify-center
                                            ma-0
                                            >
                                            <v-progress-circular indeterminate color="grey lighten-1"></v-progress-circular>
                                        </v-layout>
                                    </template>
                                </v-img>
                            </v-card>
                        </v-col>
                        <v-col cols="6" md="7">
                            <div class="d-flex align-center" style="height: 170px">
                                <p>
                                    <a :href="`#/About%20Us/Organization%20Structure/profile/${head.Title.split('#')[0].length > 1 ? head.Title.split('#')[1] : head.Title.split('#')[1]}`" class="title">{{head.Title.split('#').length > 0 ? head.Title.split('#')[1] : ''}}</a><br>
                                    <span class="subheading text-xs-center">{{head.Title.split('#')[0]}}</span>
                                </p>
                            </div>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </div>
        <div>
            <div class="ql-editor mt-5" v-html="contents[0].Body"></div>
        </div>
    </div>
</template>
<script>
    export default {
        props: ['contents'],
        data: () =>({
            divisionHeads: [],
            loadingPage: true
        }),
        mounted () {
            this.$http.get(`${this.$url}/pagination/2/Division%20Heads?limit=20&page=0&sort=content_order`).then((response) => {
                this.divisionHeads = response.data.data.rows
                this.loadingPage = false
                // console.log(this.divisionHeads)
            })
        },
        methods: {
            getWithoutImages (files) {
                return files.filter(item => !item.FileType.includes('image'))
            },
            getImage(item) {
                console.log('item.Files')
                if (item && item.Files && item.Files.length > 0) {
                    let images = item.Files.filter(obj => obj.FileType.includes('image'))
                    if (images.length > 0) {
                    return `${this.$url}/downloadfile/${images[0].ID}`
                    }
                    else {
                    return ''
                    }
                }
                else {
                    return ''
                }
            }
        }
    }
</script>